import script from "./ProductConfigModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductConfigModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductConfigModal.vue?vue&type=style&index=0&id=64dfb8cb&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64dfb8cb"]])

export default __exports__